export enum VideoStartOptionEnum {
	START_CLICK = 'start_click',
	START_AUTO = 'start_auto'
}
